import { useEffect, FC, useState } from 'react';
import { EftWithdrawTransactionResponse } from 'vopay';
import EftWithdrawTransactionInfo from './EftWithdrawTransactionInfo';
import useFetchEFTWithdrawTransaction from '@/hooks/useApi/useFetchEFTWithdrawTransaction';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

type EftWithdrawTransactionProps = {
  TransactionID: string;
  Notes: string;
  isParent?: boolean;
  jwt: string;
};

const EftWithdrawTransactionContainer: FC<EftWithdrawTransactionProps> = ({
  TransactionID,
  Notes,
  isParent = false,
  jwt,
}) => {
  const { userSettings } = useUserSettingsProvider();
  const [eftWithdrawTransaction, getEftWithdrawTransaction] = useFetchEFTWithdrawTransaction({ bearer: jwt });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<EftWithdrawTransactionResponse>();

  useEffect(() => {
    getEftWithdrawTransaction({ TransactionID, Timezone: userSettings.timezone });
  }, [currentTransactionId, TransactionID]);

  useEffect(() => {
    if (eftWithdrawTransaction) {
      setTransaction(eftWithdrawTransaction);
    }
  }, [eftWithdrawTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return (
    <div>
      {transaction && (
        <EftWithdrawTransactionInfo transaction={transaction} Notes={Notes} isParent={isParent} jwt={jwt} />
      )}
    </div>
  );
};

export default EftWithdrawTransactionContainer;
